import React from 'react';
import PropTypes from 'prop-types';
import {
  Table,
  TableBody,
  TableHeader,
  TableRow,
  TableHeaderColumn,
  TableSortableHeaderColumn,
} from '@unite-us/app-components';
import ReferralTableRow from './ReferralTableRow';

const ReferralTableView = (props) => {
  const {
    referrals,
    styles,
    groupId,
    isCC,
    sortBy,
    sortDirection,
    fetchReferrals,
    onSortChange,
  } = props;

  const setSort = ({ sortBy: sortid, sortDirection: sortD }) => {
    fetchReferrals(1, sortid, sortD);
    if (onSortChange) {
      onSortChange(sortid, sortD);
    }
  };

  return (
    <div className="referral-table-view">
      <Table id="referral-table-view" noBorder>
        <TableHeader
          adjustForCheckbox={false}
          displaySelectAll={false}
        >
          <TableRow>
            <>
              <TableHeaderColumn />
              <TableHeaderColumn>
                Service Type
              </TableHeaderColumn>

              <TableSortableHeaderColumn
                colName={'created_at'}
                sortBy={sortBy}
                sortDirection={sortDirection}
                setSort={setSort}
              >
                Date Sent
              </TableSortableHeaderColumn>

              <TableHeaderColumn style={{ minWidth: '65px' }}>
                Status
              </TableHeaderColumn>

              <TableHeaderColumn>
                Sending Organization
              </TableHeaderColumn>

              <TableHeaderColumn>
                Receiving Organization
              </TableHeaderColumn>

              <TableSortableHeaderColumn
                colName={'updated_at'}
                sortBy={sortBy}
                sortDirection={sortDirection}
                setSort={setSort}
              >
                Last Updated
              </TableSortableHeaderColumn>
            </>
          </TableRow>
        </TableHeader>
        <TableBody
          displayRowCheckbox={false}
          showRowHover
        >
          {
            referrals.map((referral, index) => (
              <ReferralTableRow
                key={referral.id}
                isCC={isCC}
                referral={referral}
                index={index}
                styles={styles}
                groupId={groupId}
              />
            ))
          }
        </TableBody>
      </Table>
    </div>
  );
};

ReferralTableView.propTypes = {
  referrals: PropTypes.array.isRequired,
  groupId: PropTypes.string.isRequired,
  isCC: PropTypes.bool.isRequired,
  styles: PropTypes.shape({
    status: PropTypes.object.isRequired,
  }).isRequired,
  sortBy: PropTypes.string.isRequired,
  sortDirection: PropTypes.string.isRequired,
  fetchReferrals: PropTypes.func.isRequired,
  onSortChange: PropTypes.func,
};

ReferralTableView.defaultProps = {
  styles: {
    status: { textTransform: 'capitalize', minWidth: '65px' },
  },
};

export default ReferralTableView;
